<section class="workout-list">
  <header class="col-12">
    <mat-tab-group mat-stretch-tabs animationDuration="0ms" class="w-100">
      <mat-tab [label]="'pages.programsTabName' | translate">
        <div class="program-list" infinite-scroll [infiniteScrollDistance]="scrollDistance" class="w-100"
          [infiniteScrollThrottle]="50" (scrolled)="onProgramScrollEnd()">
          <fitscovery-ui-program-list-card [programData]="programData | isDisplayed">
          </fitscovery-ui-program-list-card>
        </div>
      </mat-tab>
    </mat-tab-group>
  </header>
</section>